import React from 'react'
import { Empty } from 'antd-mobile'

export default function Emptyer(props) {
    return <Empty
        style={{ padding: '64px 0' }}
        imageStyle={{ width: 128 }}
        description={props.desc || '暂无数据'}
    />
}
